// hooks/useAccessLogs.jsx

// hooks/useAccessLogs.jsx
import { useState, useEffect } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { useAuth } from "../hooks/useAuth";

const firestore = getFirestore();

const useAccessLogs = () => {
  const { currentUser } = useAuth();
  const [logs, setLogs] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentUser?.uid) {
      setLoading(false);
      return;
    }

    const fetchLogs = async () => {
      try {
        setLoading(true);
        const logsCollection = collection(
          firestore,
          "users",
          currentUser.uid,
          "action_logs"
        );
        const logsSnapshot = await getDocs(logsCollection);

        if (logsSnapshot.empty) {
          setLogs({});
          setLoading(false);
          return;
        }

        let logsData = {};

        logsSnapshot.forEach((doc) => {
          const log = doc.data();
          // 🔥 Use lockId if available, otherwise fallback to deviceId
          const groupId = log.lockId || log.deviceId || "unknown"; 
          if (!logsData[groupId]) {
            logsData[groupId] = [];
          }
          logsData[groupId].push({ id: doc.id, ...log });
        });

        setLogs(logsData);
      } catch (err) {
        console.error("Error fetching logs:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, [currentUser]);

  return { logs, loading, error };
};

export default useAccessLogs;
